import { PageHeader, Content, Right } from './BasicContainer.style.js';

export const BasicContainer = ({ children, title, right }) => {
  return (
    <>
      <PageHeader>
        <h1>{title}</h1>
        <hr />
        <Right>{right}</Right>
      </PageHeader>

      <Content>{children}</Content>
    </>
  );
};
